import type { FansPage } from '@/features/clubs/types'
import type { LeaderboardPageData } from '@/features/leaderboard/usePagedLeaderboard'
import { apiRequest } from '@/shared/api/client'

import { entryToRow } from '../adapters'
import type { FansLeaderboardRow, FansLeaderboardScope } from '../types'

export async function fetchFansLeaderboardPage(
  scope: FansLeaderboardScope,
  page: number,
  pageSize: number,
  /** The page's language: the club's sport comes localized (BAT-860). */
  lang?: string
): Promise<LeaderboardPageData<FansLeaderboardRow>> {
  const response = await apiRequest<Partial<FansPage>>({
    path: '/api/v2/leaderboards/fans',
    method: 'GET',
    query: {
      ...(scope.clubId ? { club_id: scope.clubId } : {}),
      ...(scope.sportType ? { sport_type: scope.sportType } : {}),
      page,
      page_size: pageSize
    },
    ...(lang ? { headers: { Lang: lang } } : {}),
    format: 'json'
  })

  return {
    rows: (response.items ?? []).map(entry => entryToRow(entry)),
    total: response.total ?? 0
  }
}
